import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import App from './App';
import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from 'react-router-dom';
import store from "./store/store";
import { loginUser } from "store/authSlice";

import { Provider } from "react-redux";
import AppContainer from "./AppContainer";

const checkAuthToken = () => {
  const token = localStorage.getItem("authToken");
  if (token) {
    try {
      // Декодируем токен (в реальном проекте нужно проверять подпись)
      const payload = JSON.parse(atob(token.split(".")[1]));
      // Проверяем срок действия токена
      if (payload.expires > Date.now() / 1000) {
        store.dispatch(loginUser.fulfilled());
        return true;
      }
    } catch (e) {
      console.error("Ошибка проверки токена:", e);
    }
    // Удаляем невалидный токен
    localStorage.removeItem("authToken");
  }
  return false;
};

checkAuthToken();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppContainer />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
